/* eslint-disable react/self-closing-comp */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { CheckCircle } from '@gvlab/react-icons';

const Form3 = ({ authCtx }) => (
  <div>
    <div className="mb-8 text-center">
      <CheckCircle sx={{ fontSize: 70, color: 'green' }} />
      <h1 className="my-3 text-4xl font-bold text-black dark:text-gray-400">Success</h1>
    </div>
    <div className="mb-8 text-left">
      <p className="text-sm dark:text-gray-400 text-gray-400">
        Your password has been changed successfully.
      </p>
    </div>
    <div className="space-y-12 ng-untouched ng-pristine ng-valid">
      <div className="space-y-2">
        <div className="text-center mt-4">
          Return to the{' '}
          <a rel="noopener noreferrer" href="/auth/login" className="underline">
            Sign in
          </a>
          .
        </div>
      </div>
    </div>
  </div>
);

export default Form3;
